import {Button} from "@varymadellc/my-weed-club-component-library";
import {ButtonVariantProps} from "@varymadellc/my-weed-club-component-library";
import {FiX} from "react-icons/fi";

export interface QueueModalWrapperLinkProps {
    setIsOpen: (value: string) => void;
    children: JSX.Element;
}

export default function QueueModalWrapper({setIsOpen, children}: QueueModalWrapperLinkProps) {
    return (
        <div className="w-full sm:w-[500px] md:w-[600px] lg:w-[800px] relative bg-dark-black text-white p-4 border-secondary border rounded">
            <Button className="absolute right-0 top-0 z-10" variant={'link' as ButtonVariantProps.link}>
                <FiX onClick={() => setIsOpen('')} className="fill-white text-white w-8 h-8"/>
            </Button>
            {children}
        </div>
    );
}